import React from 'react';
import { BaseOperateView, IFramework } from '@/framework';
import { LayerType } from '@/version-types';
import { useCropInteraction } from '../hooks/use-crop-interaction';
import { useCropImgState } from '../states/crop-img-state';
import CropStage from './crop-stage';

const CropImgWrap: React.FC<{
    scale: number;
    stageWidth: number;
    stageHeight: number;
    framework: IFramework;
    identity: string;
    isAutoCutoutLayer: boolean;
}> = ({ scale, framework, isAutoCutoutLayer }) => {
    const currentLayer = useCropImgState()((state) => state.currentLayer);
    const { getPreviewLayer, previewTick } = useCropInteraction(framework, scale, isAutoCutoutLayer);

    if (!currentLayer || currentLayer.layerType !== LayerType.IMAGE_LAYER) {
        return null;
    }

    const previewLayer = getPreviewLayer(currentLayer);
    void previewTick;

    if (!previewLayer) {
        return null;
    }

    return (
        <BaseOperateView layer={{ ...previewLayer, id: `${previewLayer.id}-crop-img` }}>
            <CropStage layer={previewLayer} stageScale={scale} isAutoCutoutLayer={isAutoCutoutLayer} />
        </BaseOperateView>
    );
};

export default CropImgWrap;
